import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

import S from './Form.styled'
import FormInput from './items/Input'
import FormCheckbox from './items/Checkbox'
import FormButton from './items/Button'

const Form = ({ className, children }) => {
  return <S.Form className={className}>{children}</S.Form>
}

Form.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}

const Input = forwardRef((props, ref) => <FormInput ref={ref} {...props} />)
Form.Input = Input

const Checkbox = (props) => <FormCheckbox {...props} />
Form.Checkbox = Checkbox

const Button = (props) => <FormButton {...props} />
Form.Button = Button

export default Form
